import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAsJ-iX-iIkb7ihlQeq6JpFBD1chckihLA",
  authDomain: "able-the-fanatic.firebaseapp.com",
  projectId: "able-the-fanatic",
  storageBucket: "able-the-fanatic.appspot.com",
  messagingSenderId: "571116718172",
  appId: "1:571116718172:web:ccca1267e72a26c34cbe99",
  measurementId: "G-LJV55YL51J"
};

// Analytics once per page load (App used to initialise Firebase on every render). Skipped in tests
// and wherever the browser does not support it, so a blocked tracker cannot break the page.
export function startAnalytics() {
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  isSupported()
    .then((ok) => ok && getAnalytics(initializeApp(firebaseConfig)))
    .catch(() => {});
}
